import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { tagParser } from '../../../js/modules/utilities'

import imageLargeX2 from './2880x1240.jpg'
import imageSmallX2 from './pro.jpg'
import title from './title.svg'

export const Iphone16 = ({ type }) => {
   const data = {
      preco: {
         cookieValue: JSON.stringify({ precommande_iphone_16: 1 }),
         title: title,
         subtitle: '[price]70€[/price] de remise immédiate.',
         imageLargeX2: imageLargeX2,
         imageSmallX2: imageSmallX2,
         button: {
            label: 'Précommander',
            URL: 'https://boutique.orange.fr/mobile/mobiles-et-smartphones?segment=famille16',
            analytics: {
               pdbZid: 'acc-digital_' + dataStoreHP.segRefZ + '_event_preco',
               oeventCategory: 'zone_evenementielle',
               oeventAction: 'precommande_apple_16',
               oeventLabel: 'https://boutique.orange.fr/mobile/mobiles-et-smartphones?segment=famille16',
               oeventOther: JSON.stringify({
                  track_refZ: 'acc-digital_' + dataStoreHP.segRefZ + '_event_preco',
               }),
            },
         },
         DAS: 'DAS tête : 1,24 W/kg, tronc : 1,91 W/kg, membre : 1,48 W/kg.',
      },
      commande: {
         videoDesktop: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/iphone16/video_commande_desktop.mp4',
         videoMobile: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/iphone16/video_commande_mobile.mp4',
         posterStartDesktop: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/iphone16/poster_start_desktop.jpg',
         posterEndDesktop: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/iphone16/poster_end_desktop.jpg',
         posterStartMobile: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/iphone16/poster_start_mobile.jpg',
         posterEndMobile: 'https://cdn.woopic.com/18d8339538654b1dbf96a30e92745731/zone_evenementielle/iphone16/poster_end_mobile.jpg',
         CTA: {
            URL: 'https://boutique.orange.fr/mobile/mobiles-et-smartphones?segment=famille16',
            analytics: {
               pdbZid: 'acc-digital_' + dataStoreHP.segRefZ + '_event_commande',
               oeventCategory: 'zone_evenementielle',
               oeventAction: 'commande_apple_16',
               oeventLabel: 'https://boutique.orange.fr/mobile/mobiles-et-smartphones?segment=famille16',
               oeventOther: JSON.stringify({
                  track_refZ: 'acc-digital_' + dataStoreHP.segRefZ + '_event_commande',
               }),
            },
         },
      },
   }

   if (type === 'preco') {
      return <CampagneImage {...data.preco} />
   }

   if (type === 'commande') {
      // Cookie de capping
      const nbJoursCookie = 20
      let cookieValue = { commande_iphone_16: 1 }
      let eventCookie = document.cookie.split('; ').find((cookie) => cookie.includes('o-HPevent'))
      if (eventCookie) {
         let eventCookieValue = JSON.parse(eventCookie.split('=')[1])
         if (eventCookieValue && eventCookieValue.commande_iphone_16) {
            eventCookieValue.commande_iphone_16++
            cookieValue = eventCookieValue
         }
      }
      document.cookie = `o-HPevent=${JSON.stringify(cookieValue)}; max-age=${60 * 60 * 24 * nbJoursCookie}; path=/`

      return <CampagneVideo {...data.commande} />
   }
}

const CampagneImage = (props) => {
   useEffect(() => {
      // Cookie de capping
      const nbJoursCookie = 20
      document.cookie = `o-HPevent=${props.cookieValue}; max-age=${60 * 60 * 24 * nbJoursCookie}; path=/`
   }, [])

   return (
      <div class="campagne">
         <img src={props.title} alt="" class="title" />
         <picture>
            <source srcset={props.imageSmallX2} media="(max-width: 735px)" />
            <img src={props.imageLargeX2} alt="" class="imageFond" />
         </picture>
         <div class="content">
            <h3 class="subtitle h4" dangerouslySetInnerHTML={{ __html: tagParser(props.subtitle) }} />
            <a
               href={props.button.URL}
               class="btn btn-primary btn-inverse"
               data-pdb-zid={props.button.analytics.pdbZid}
               data-oevent-category={props.button.analytics.oeventCategory}
               data-oevent-action={props.button.analytics.oeventAction}
               data-oevent-label={props.button.analytics.oeventLabel}
               data-oevent-other={props.button.analytics.oeventOther}
            >
               {props.button.label}
            </a>
            <span class="das">{props.DAS}</span>
         </div>
      </div>
   )
}

const CampagneVideo = (props) => {
   // Video
   const [isPlaying, setIsPlaying] = useState(true)
   const [hasEnded, setHasEnded] = useState(false)
   const [videoSource, setVideoSource] = useState(window.innerWidth >= 736 ? props.videoDesktop : props.videoMobile)
   const [videoPoster, setVideoPoster] = useState(window.innerWidth >= 736 ? props.posterStartDesktop : props.posterStartMobile)
   const videoRef = useRef(null)
   const playPauseButtonRef = useRef(null)

   useEffect(() => {
      // Video
      const videoElement = videoRef.current
      const playPauseButton = playPauseButtonRef.current

      const handlePlayPause = (e) => {
         e.preventDefault()
         setHasEnded(false)
         if (videoElement.paused) {
            videoElement.play()
            setIsPlaying(true)
         } else {
            videoElement.pause()
            setIsPlaying(false)
         }
      }

      const handleVideoEnded = () => {
         setIsPlaying(false)
         setHasEnded(true)
      }

      const setTimeoutId = setTimeout(() => {
         videoElement.src = '' // Evite au navigateur de continuer à télécharger la vidéo
         setVideoPoster(window.innerWidth >= 736 ? props.posterEndDesktop : props.posterEndMobile)
         playPauseButton.style.display = 'none'
      }, 5000)

      const handlePlaying = () => {
         clearTimeout(setTimeoutId)
      }

      playPauseButton.addEventListener('click', handlePlayPause)
      videoElement.addEventListener('ended', handleVideoEnded)
      videoElement.addEventListener('playing', handlePlaying)

      return () => {
         playPauseButton.removeEventListener('click', handlePlayPause)
         videoElement.removeEventListener('ended', handleVideoEnded)
         videoElement.removeEventListener('playing', handlePlaying)
      }
   }, [])

   useEffect(() => {
      const videoElement = videoRef.current
      const handleResize = () => {
         const newVideoSource = window.innerWidth >= 736 ? props.videoDesktop : props.videoMobile
         const newVideoPoster = window.innerWidth >= 736 ? props.posterStartDesktop : props.posterStartMobile
         if (newVideoSource !== videoSource) {
            setVideoSource(newVideoSource)
            setVideoPoster(newVideoPoster)
            videoElement.load() // Reload the video with the new source
            setHasEnded(false)
            setIsPlaying(true)
         }
      }

      window.addEventListener('resize', handleResize)

      return () => {
         window.removeEventListener('resize', handleResize)
      }
   }, [videoSource, props.videoDesktop, props.videoMobile])

   return (
      <div class="campagneVideo">
         <a
            href={props.CTA.URL}
            data-pdb-zid={props.CTA.analytics.pdbZid}
            data-oevent-category={props.CTA.analytics.oeventCategory}
            data-oevent-action={props.CTA.analytics.oeventAction}
            data-oevent-label={props.CTA.analytics.oeventLabel}
            data-oevent-other={props.CTA.analytics.oeventOther}
         >
            <video
               id="bgVideo"
               ref={videoRef}
               playsinline // Mobile browsers will play the video right where it is instead of the default, which is to open it up fullscreen while it plays.
               autoplay
               preload="auto"
               muted
               poster={videoPoster}
            >
               <source src={videoSource} type="video/mp4" />
            </video>
            <button
               type="button"
               class={`video__playpause ${hasEnded ? 'icon icon-reload' : isPlaying ? 'video__playpause--pause' : 'video__playpause--play'}`}
               ref={playPauseButtonRef}
            ></button>
         </a>
      </div>
   )
}
